import LinearProgress from '@mui/material/LinearProgress'
import { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { useReactiveVar } from '@apollo/client'
import { publicPasswordValidatedVar } from '../../providers/apollo/cache'
import useBucketShareByIdProtected from './hooks/useBucketShareByIdProtected'
import Loader from '../../components/Loader'

const FullScreen = lazy(() => import('./FullScreen'))
const Gallery = lazy(() => import('./Gallery'))
const NotFound = lazy(() => import('../../components/NotFound'))
const PasswordPrompt = lazy(() => import('./components/password/PasswordPrompt'))

function ProtectedRoutes() {
  const { shareProtectedDetails, loading } = useBucketShareByIdProtected()
  const publicPasswordValidated = useReactiveVar(publicPasswordValidatedVar)

  const isPasswordProtected = shareProtectedDetails?.passwordProtected

  if (loading) {
    return <Loader />
  }

  if (isPasswordProtected && !publicPasswordValidated) {
    return <PasswordPrompt />
  }

  return (
    <Routes>
      <Route path="media/:mediaId" element={<FullScreen />} />
      <Route path="/:mode" element={<Gallery />} />
      <Route path="album/:albumId" element={<Gallery />}>
        <Route path=":mode" element={<Gallery />} />
        <Route path="media/:mediaId" element={<Gallery />} />
      </Route>
      <Route path="/" element={<Gallery />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default function Router() {
  return (
    <Suspense fallback={<LinearProgress />}>
      <ProtectedRoutes />
    </Suspense>
  )
}
